import TagInput from './TagInput.view';

export default TagInput;
